import * as React from "react";
import "./header.css";
import { NavLink } from "react-router-dom";

interface IState {
  static: boolean;
  close: string;
}
export default class Header extends React.Component<any, IState> {
  constructor(props: any) {
    super(props);
    this.state = {
      close: "right-side",
      static: this.props.static
    };
    this.openBanner = this.openBanner.bind(this);
    this.closeBanner = this.closeBanner.bind(this);
  }

  openBanner() {
    this.setState({ close: "right-side activing" });
    setTimeout(() => {
      this.setState({ close: "right-side activing active" });
    }, 5);
  }
  closeBanner() {
    this.setState({ close: "right-side activing" });
    setTimeout(() => {
      this.setState({ close: "right-side" });
    }, 300);
  }
  render() {
    const correctClassName = this.state.static ? "header static" : "header";
    return (
      <header className={correctClassName}>
        <NavLink to="/" className="logo-area">
          <img src="/images/Logo.svg" className="logo" alt="logo" />
        </NavLink>
        <div className="mobile-burger" onClick={this.openBanner}>
          <span className="mobile-burger-line" />
          <span className="mobile-burger-line" />
          <span className="mobile-burger-line" />
        </div>
        <div className={this.state.close}>
          <div className="header-close" onClick={this.closeBanner} />
          <NavLink to="/vorur">Vörur</NavLink>
          <NavLink to="/um-okkur">Um okkur</NavLink>
          <NavLink to="/hafa-samband">Hafa samband</NavLink>
        </div>
      </header>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Shared/header/header.tsx